export const SUPPORTED_LANGUAGES = ["en", "ru", "es"];
